import type { Nullable } from '../../types';

type D = Date | string;

function isDateBefore(d1: Date, d2: Date, inclusive = false) {
    return inclusive ? d1 <= d2 : d1 < d2;
}

export function isDateInRange(
    date: D,
    range: [Nullable<D>, Nullable<D>],
    inclusive: '[]' | '()' | '[)' | '(]' = '[]'
) {
    const [start, end] = range;
    const currentDate = new Date(date);
    const startDate = start ? new Date(start) : null;
    const endDate = end ? new Date(end) : null;
    const includeStart = inclusive[0] === '[';
    const includeEnd = inclusive[1] === ']';

    if (!startDate && !endDate) {
        return true;
    }

    if (!startDate && endDate) {
        return isDateBefore(currentDate, endDate, includeEnd);
    }

    if (startDate && !endDate) {
        return isDateBefore(startDate, currentDate, includeStart);
    }

    if (startDate && endDate) {
        return (
            isDateBefore(startDate, currentDate, includeStart) &&
            isDateBefore(currentDate, endDate, includeEnd)
        );
    }

    return false;
}
